import React from "react";

import { Menu, MenuItem, MenuProps, Typography } from "@mui/material";

import type {
  Recommendation,
  RecommendationAction,
} from "@app/analytics/types";
import * as RecommendationUtils from "@app/analytics/utils/recommendationUtils";

import { DefaultBadge } from "@rui/Badge";
import { Row } from "@rui/Stack";

interface RecommendationActionMenuProps extends MenuProps {
  recommendation: Recommendation;
  onClickAction: (action: RecommendationAction) => void;
}

const RecommendationActionMenu = ({
  recommendation,
  anchorEl,
  open,
  onClose,
  onClickAction,
}: RecommendationActionMenuProps) => {
  const defaultAction = RecommendationUtils.getDefaultAction(recommendation);
  const alternativeActions =
    RecommendationUtils.getAlternativeActions(recommendation);

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          boxShadow: (theme) => theme.shadows[4],
        },
      }}
    >
      {defaultAction && (
        <MenuItem
          sx={{ minWidth: "80px" }}
          key={defaultAction.label}
          onClick={() => onClickAction(defaultAction)}
        >
          <Row variant="apart" sx={{ width: "100%" }} spacing={1}>
            <Typography variant="bodySecondaryReg">
              {defaultAction.label}
            </Typography>
            {recommendation.actions.length > 1 && <DefaultBadge />}
          </Row>
        </MenuItem>
      )}
      {alternativeActions.map((action) => (
        <MenuItem
          sx={{ minWidth: "80px" }}
          key={action.label}
          onClick={() => onClickAction(action)}
        >
          <Row variant="apart" sx={{ width: "100%" }}>
            <Typography variant="bodySecondaryReg">{action.label}</Typography>
          </Row>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default RecommendationActionMenu;
